import Vue from 'vue'
import MenuItem from "./components/MenuItem.vue";

export function initMenuItem(element: string) {
    if (!document.getElementById(element)) return;
    const vm = new Vue({
        el: '#' + element,
        components: {
            'menu-item': MenuItem
        }
    })
}
